import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  // Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import Chart from 'react-apexcharts';
import { TotalOrder } from '../../../store/dashboardReport/api/interface';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { customFormatDate } from '../../../utils/customFormatDate';
import Scrollbar from '../../../components/Scrollbar';

const useChartOptions = (labels: string[], theme: any, colors: string[]) => {
  return {
    chart: {
      background: 'transparent',
    },
    colors: colors,
    dataLabels: {
      enabled: false,
    },
    labels,
    legend: {
      show: false,
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
      },
    },
    states: {
      active: {
        filter: {
          type: 'none',
        },
      },
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
    stroke: {
      width: 0,
    },
    theme: {
      mode: theme.palette.mode,
    },
    tooltip: {
      fillSeriesColor: false,
    },
  };
};

export const OverviewExpense = (props: any) => {
  const theme = useTheme();
  const { data, sx } = props;

  const labels = data?.map((item: TotalOrder) => customFormatDate(item.date));
  const series = data?.map((item: TotalOrder) => item.count);

  const colors = [
    '#EE3750',
    '#E899CD',
    '#258B27',
    '#3098AB',
    '#69A524',
    '#C05FA5',
    '#19E67F',
    '#0411E1',
    '#026751',
    '#CE8024',
    '#32B61E',
    '#AB4F60',
    '#A9F281',
    '#C0701B',
    '#6DE9BD',
    '#8B9910',
    '#3AC027',
    '#8B7CD2',
    '#4B1DA9',
    '#8FB0EA',
    '#F07A92',
    '#D05D31',
    '#0CFFD1',
    '#8D2C1C',
    '#AD7BA3',
    '#463D78',
    '#6B4171',
    '#1907C6',
    '#019E2C',
    '#3CD1AE',
    '#E18888',
  ];

  const chartOptions = useChartOptions(labels, theme, colors);

  return (
    <Card sx={sx}>
      <CardHeader title='Total Orders' />
      <CardContent>
        <Chart
          height={300}
          options={chartOptions}
          series={series}
          type='donut'
          width='100%'
        />
        <Stack
          alignItems='center'
          direction='column'
          justifyContent='center'
          spacing={2}
          sx={{ mt: 2 }}
        >
          <Accordion sx={{ width: '100%' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1-content'
              id='panel1-header'
            >
              <Typography variant='h5'>Details</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Scrollbar>
                <TableContainer sx={{ position: 'relative' }}>
                  <Table size={'medium'}>
                    <TableHead>
                      <TableRow>
                        <TableCell align='center'>{'Date'}</TableCell>
                        <TableCell align='center'>{'No of Order'}</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {series &&
                        series?.map((item: any, index: number) => (
                          <TableRow key={item}>
                            <TableCell align='center'>
                              {labels[index]}
                            </TableCell>
                            <TableCell align='center'>{item}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
              {/* {series &&
                series?.map((item: any, index: number) => {
                  const label = labels[index];

                  return (
                    <Box
                      key={label}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        mt: 0,
                      }}
                    >
                      <Typography
                        // color='text.secondary'
                        variant='h6'
                      >
                        {label} :
                      </Typography>
                      <Typography variant='h6'> &nbsp;{item}</Typography>
                    </Box>
                  );
                })} */}
            </AccordionDetails>
          </Accordion>
        </Stack>
      </CardContent>
    </Card>
  );
};
